import { useEffect, useRef, useState } from "react";

const lessons = [
  {
    title: "Saying Sorry",
    subtitle: "Cleaning up",
    icon: "ri-heart-3-line",
  },
  {
    title: "Honesty",
    subtitle: "Sharing & truth",
    icon: "ri-heart-3-line",
  },
  {
    title: "Listening",
    subtitle: "Staying safe",
    icon: "ri-heart-3-line",
  },
  {
    title: "Bravery",
    subtitle: "Teamwork & helping",
    icon: "ri-heart-3-line",
  },
  {
    title: "Kindness",
    subtitle: "Patience & understanding",
    icon: "ri-heart-3-line",
  },
];

export default function LessonsSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="relative py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50 overflow-hidden">
      <div
        ref={ref}
        className={`relative z-10 w-full transition-all duration-700 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        <div className="max-w-5xl mx-auto mb-10 md:mb-14">
          <img
            src="../../../../images/494d10460132d98fe4c206dd01a97c31.png"
            alt="Cappy and Barry Adventures - Values Woven Into Every Story"
            className="w-full h-auto rounded-2xl shadow-2xl shadow-foreground-950/10 object-cover"
          />
        </div>

        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-sm font-semibold rounded-full mb-4">
            Life Lessons
          </span>
          <h2 className="font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 mb-4">
            Values Woven Into Every Story
          </h2>
          <p className="text-foreground-500 text-base md:text-lg max-w-2xl mx-auto">
            These books gently guide children toward understanding the values
            that matter most.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6">
          {lessons.map((lesson, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl p-6 md:p-8 text-center border border-background-200 shadow-lg shadow-foreground-950/10 hover:border-primary-300 transition-all duration-300 hover:shadow-xl hover:shadow-foreground-950/15 hover:-translate-y-1 relative ${
                visible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-6"
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="w-14 h-14 md:w-16 md:h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${lesson.icon} text-primary-500 text-xl md:text-2xl`} />
              </div>
              <h4 className="font-bold text-lg text-foreground-950 mb-1">
                {lesson.title}
              </h4>
              <p className="text-sm text-foreground-500">{lesson.subtitle}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}